import { provideLuzulaAuth } from '@luzula/luzula-lib';
import { environment } from '../environments/environment';

// Realm PRO BUILD-PROFIL (environment.keycloakRealm): *-bpweb.luzula.de -> 'luzula',
// bpweb.lfmv.de -> 'waldmv'. Fallback 'waldmv' (historischer Default, falls ein Profil
// das Feld nicht setzt). Die luzula-api akzeptiert beide Realms (KEYCLOAK_REALMS=
// luzula,waldmv); die Keycloak-URL ist zentral in der Lib (id.waldkonzepte.de); der
// Client heisst in beiden Realms 'bpweb'.
//
// Bearer-Token an den KONFIGURIERTEN API-Host haengen — leitet sich aus
// environment.apiBaseUrl ab. Ohne passenden bearerHost bekaeme die luzula-api keinen
// Token und antwortete mit 401.
export const provideKeycloakAngular = () => {
	const realm = (environment as { keycloakRealm?: string }).keycloakRealm ?? 'waldmv';
	return provideLuzulaAuth(realm, 'bpweb', { bearerHosts: [new URL(environment.apiBaseUrl).host] });
};
